import { Box, Container, useMediaQuery } from '@mui/material'
import { CompetitionDetailTable } from 'pages/purchase-pages/competition-detail/CompetitionDetailTable'
import { PurchaseLayout } from 'hoc/PurchaseLayout'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useProcurementRequirementsQuery } from 'services/lot/procurement-requirements'
import { useQueryState } from 'react-router-use-location-state'
import { useTranslation } from 'react-i18next'

const breadCrumbs = [
  {
    id: 'home',
    title: 'Ana səhifə',
    path: '/',
  },
  {
    id: 'OPEN_TENDER',
    title: 'Açıq tender (e-tender)',
  },
]

export const CompetitionProductDetail: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 1200px)')
  const { id } = useParams()
  const [breadCrumbItems, setBreadCrumbItems] = useState(breadCrumbs)
  const rowsPerPage = 10
  const [page, setPage] = useQueryState('page', 0)
  const { t } = useTranslation()

  const args = {
    page,
    size: rowsPerPage,
    lotId: id ?? '',
  } as const

  const { data: procurementRequirement } = useProcurementRequirementsQuery(args, {
    skip: !id,
  })

  if (procurementRequirement === undefined) {
    return <></>
  }

  return (
    <>
      <PurchaseLayout maxWidth={false} breadCrumbItems={breadCrumbItems}>
        {procurementRequirement && procurementRequirement.items.length > 0 && (
          <Container maxWidth={false} disableGutters={isMobile ? false : true}>
            <Box
              sx={{
                padding: { xs: '20px 0', md: '50px 0', background: '#fafbfb' },
              }}
            >
              <Container maxWidth="lg" disableGutters={isMobile ? false : true}>
                <CompetitionDetailTable data={procurementRequirement} />
              </Container>
            </Box>
          </Container>
        )}
      </PurchaseLayout>
    </>
  )
}
